import { Link } from 'react-router-dom';
import styles from './breadcrumbs.module.scss';
import HouseIcon from "../../../assets/images/house.png";
import React from 'react';
import Proptypes from 'prop-types';

const Breadcrumbs = ({path, mainPageTitle, subPageTitle}) => {
  return (
    <div className={styles["breadcrumb_container"]}>
    <div>
      <h3>{subPageTitle}</h3>
    </div>
    <div className={styles["pathname"]}>
      <Link to={path}>
        <img src={HouseIcon} alt="house" width={30} height={30} />
      </Link>
      <div>
        / {mainPageTitle} / <span className={styles["active_text"]}>{subPageTitle}</span>
      </div>
    </div>
  </div>
  )
}

Breadcrumbs.propTypes = {
  path: Proptypes.string,
  mainPageTitle: Proptypes.string,
  subPageTitle: Proptypes.string
}

export default Breadcrumbs